import React from 'react';
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../../component/Page/Page";
import UserForm from "../../component/User/UserForm";

class UserFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Cadastros"/>,
      <BreadcrumbItem key={2} title="Lista de usuários" to="/list/users"/>,
      < BreadcrumbItem key={3} title="Dados do usuário" active={true}/>];
    return (
        <Page title="Dados do Usuário" breadcrumbs={breadcrumbs}>
          <UserForm match={match} history={history}/>
        </Page>
    );
  }
}

export default UserFormPage;



// WEBPACK FOOTER //
// ./src/user/application/UserFormPage.js